import script from "./NewyorkView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewyorkView.vue?vue&type=script&setup=true&lang=js"

import "./NewyorkView.vue?vue&type=style&index=0&id=55250598&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55250598"]])

export default __exports__